import { Box } from '@mui/material';
import React from 'react';
import { Lookup } from '../../../../contexts/MetadataContext';
import PropertyTypeCard from './PropertyTypeCard';

interface PropertyTypeGridProps {
  options: Lookup[];
  value: string;
  onChange: (lookupKey: string) => void;
}

// Using flexbox with fixed-width cards (192px) that wrap naturally
// This creates a responsive layout where cards maintain their size
// but the number of cards per row adjusts based on container width
// The flex container allows cards to flow naturally without forcing
// specific column counts at breakpoints
const PropertyTypeGrid: React.FC<PropertyTypeGridProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: { xs: 2, sm: 3 },
        // Cards will naturally wrap based on container width
        // No need for explicit breakpoints - flex handles it
        justifyContent: 'flex-start',
        // On very small screens, we might want to center single cards
        '@media (max-width: 400px)': {
          justifyContent: 'center',
        },
      }}
    >
      {options.map((option) => (
        <PropertyTypeCard
          key={option.LookupKey}
          option={option}
          isSelected={value === option.LookupValue}
          onClick={() => onChange(option.LookupKey)}
        />
      ))}
    </Box>
  );
};

export default PropertyTypeGrid;
